module.exports = __webpack_public_path__ + "img/image_news_TXT_collabo03.a7629288.png";